export const MOBILE_M_BREAKPOINT = 375; // Screen width of 375px or below
export const MOBILE_L_BREAKPOINT = 425;
export const MOBILE_2L_BREAKPOINT = 480;
export const MOBILE_3L_BREAKPOINT = 625;
export const MOBILE_4L_BREAKPOINT = 670;
export const TABLET_BREAKPOINT = 768;
export const DESKTOP_BREAKPOINT = 1024;
export const DESKTOP_L_BREAKPOINT = 1440;
export const DESKTOP_4K_BREAKPOINT = 2560;

export const CURRENCIES = {
  COIN: 'coin',
  DEMO_COIN: 'demo-coin',
  DIAMOND: 'diamond',
};

export const DESKTOP_CONTENT_SIDE_PADDING = 90;

export const TABLE_AREA_Z_INDEX = {
  RESULT: 5,
  CHIP: 5,
  ACTION_animations: 4,
  PLAYER_IN_TABLE: 4,
  UPPER_CONTROL_BUTTONS: 7,
  TABLE_MESSAGE: 5,
  TABLE_SECTION: 6,
};

export const LANG_CODE = {
  ZH_HK: 'zh-HK',
  ZH_TW: 'zh-TW',
  EN_US: 'en-US',
  AR: 'ar',
  HI: 'hi',
  JA: 'ja',
  KO: 'ko',
  MN: 'mn',
  ES: 'es',
};

export const langList = [
  // Default language placed on top
  // {
  //   label: '繁體中文',
  //   value: LANG_CODE.ZH_HK,
  //   emojiUnicode: '🇭🇰',
  //   icon: '/icon/menu/hongKongFlag.svg',
  // },
  {
    label: '中文(台灣)',
    value: LANG_CODE.ZH_HK,
    emojiUnicode: '🇹🇼',
    icon: '/images-mobile/country/TWN.webp',
  },
  {
    label: ' English',
    value: LANG_CODE.EN_US,
    emojiUnicode: '🇬🇧',
    icon: '/icon/menu/unitedKingdomFlag.svg',
  },
  {
    label: 'العربية',
    value: LANG_CODE.AR,
    emojiUnicode: '🇦🇪', // UAE as an example for Arabic-speaking regions
    icon: '/images-mobile/country/ARE.webp',
  },
  {
    label: 'हिन्दी',
    value: LANG_CODE.HI,
    emojiUnicode: '🇮🇳',
    icon: '/images-mobile/country/IND.webp',
  },
  {
    label: '日本語',
    value: LANG_CODE.JA,
    emojiUnicode: '🇯🇵',
    icon: '/images-mobile/country/JPN.webp',
  },
  {
    label: '한국어',
    value: LANG_CODE.KO,
    emojiUnicode: '🇰🇷',
    icon: '/images-mobile/country/south-korea.webp',
  },
  {
    label: 'Монгол',
    value: LANG_CODE.MN,
    emojiUnicode: '🇲🇳',
    icon: '/images-mobile/country/MNG.webp',
  },
  {
    label: 'Español',
    value: LANG_CODE.ES,
    emojiUnicode: '🇪🇸',
    icon: '/images-mobile/country/ESP.webp',
  },
];

export const ACCOUNT_REGISTRATION_TYPE = {
  EMAIL: 'EMAIL',
  METAMASK: 'METAMASK',
  WALLET: 'WALLET',
};

export const WALLET_TRANSACTION_STATUS = {
  COMPLETED: 'COMPLETED',
  PENDING: 'PENDING',
};

export const WALLET_TRANSACTION_TYPE = {
  DEPOSIT: 'DEPOSIT',
  WITHDRAWAL: 'WITHDRAWAL',
};
